import * as React from 'react'
import { ProductOptions } from '@components/products/product-options'
import { useSubscriptionProductOptions } from '@modules/subscription/products/create/options/use-subscription-product-options'

export const DefaultSubscriptionProductOptions = (): React.ReactNode => {
  const { options } = useSubscriptionProductOptions()
  return <ProductOptions options={options} allowDuplicates />
}
